import React from 'react';

const Grades = () => (
  <div style={{ padding: 32 }}>
    <h1>Student Grades</h1>
    <p>View your grades here.</p>
  </div>
);

export default Grades;
